import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterHorizontal32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconGutterHorizontal32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 8a1 1 0 1 0 0-2 4 4 0 0 0-4 4v12a4 4 0 0 0 4 4 1 1 0 1 0 0-2 2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m-9 1a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1M6 25a1 1 0 0 1 1-1 2 2 0 0 0 2-2V10a2 2 0 0 0-2-2 1 1 0 0 1 0-2 4 4 0 0 1 4 4v12a4 4 0 0 1-4 4 1 1 0 0 1-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterHorizontal32);
